import { createBasicSelector } from 'util/redux'
import { selectBooleanPreferenceByName } from './selectBooleanPreferenceByName'

export const selectCurrentUserPreferReassignTicketOnNote = createBasicSelector(
  state => selectBooleanPreferenceByName(state, 'reassign_ticket_on_note', true)
)
